import React from 'react';
import '../../styles/empreendimentosStyle/PaginacaoEmpreendimentos.css';

interface Props {
  pagina: number;
  totalPaginas: number;
  onPageChange: (novaPagina: number) => void;
}

export default function PaginacaoEmpreendimentos({ pagina, totalPaginas, onPageChange }: Props) {
  return (
    <div className="paginacao-container">
      <button
        onClick={() => onPageChange(pagina - 1)}
        disabled={pagina <= 1}
      >
        {'<'}
      </button>
      <span>Página {pagina} de {totalPaginas}</span>
      <button
        onClick={() => onPageChange(pagina + 1)}
        disabled={pagina >= totalPaginas}
      >
        {'>'}
      </button>
    </div>
  );
}
